module.exports = __webpack_public_path__ + "img/slide1.20cf0590.jpg";